module.exports = __webpack_public_path__ + "fonts/icomoon.885e718.ttf";